/**
 * XP/Level hesapları — backend `utils/level.py` ile aynı eğri.
 */

export const LEVEL_CAP = 100;

export function xpForNextLevel(level: number): number {
  if (level >= LEVEL_CAP) return 0;
  if (level < 1) level = 1;
  return Math.round(100 * Math.pow(level, 1.5));
}

export function xpToLevel(totalXp: number): {
  level: number;
  xpIntoLevel: number;
  xpForNext: number;
} {
  if (!totalXp || totalXp < 0) totalXp = 0;
  let level = 1;
  let remaining = Math.floor(totalXp);
  while (level < LEVEL_CAP) {
    const need = xpForNextLevel(level);
    if (remaining < need) {
      return { level, xpIntoLevel: remaining, xpForNext: need };
    }
    remaining -= need;
    level += 1;
  }
  return { level: LEVEL_CAP, xpIntoLevel: 0, xpForNext: 0 };
}

/**
 * Seviyeye göre renk paleti — daha yüksek seviye, daha sıcak ton.
 */
export function levelColor(level: number): { ring: string; text: string; bg: string } {
  if (level >= 90) return { ring: '#ef4444', text: '#dc2626', bg: 'rgba(239,68,68,0.10)' };
  if (level >= 70) return { ring: '#f97316', text: '#ea580c', bg: 'rgba(249,115,22,0.10)' };
  if (level >= 50) return { ring: '#eab308', text: '#ca8a04', bg: 'rgba(234,179,8,0.10)' };
  if (level >= 30) return { ring: '#22c55e', text: '#16a34a', bg: 'rgba(34,197,94,0.10)' };
  if (level >= 15) return { ring: '#3b82f6', text: '#2563eb', bg: 'rgba(59,130,246,0.10)' };
  return { ring: '#94a3b8', text: '#64748b', bg: 'rgba(148,163,184,0.10)' };
}
